"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 11 12"
  }, react_1.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react_1.default.createElement("path", {
    fill: "#F0B429",
    d: "M2.848 6.2h1.964v1.2H2.848z"
  }), react_1.default.createElement("path", {
    fill: "#424A60",
    d: "M.295 0a.198.198 0 0 0-.197.2v11.6c0 .11.088.2.197.2.108 0 .196-.09.196-.2V.2C.491.09.403 0 .295 0z"
  }), react_1.default.createElement("path", {
    fill: "#FCE588",
    d: "M.491.8h4.321v5.8H.491z"
  }), react_1.default.createElement("path", {
    fill: "#FADB5F",
    d: "M4.813 1.8v4.8h-1.18a.793.793 0 0 0-.785.8c0 .442.352.8.786.8H10.902L8.742 5l2.16-3.2h-6.09z"
  }), react_1.default.createElement("path", {
    fill: "#F7C948",
    d: "M2.848 7.4c0 .442.352.8.786.8h1.179V6.6h-1.18a.793.793 0 0 0-.785.8z"
  })));
};